<template>
  <v-container>
    <v-row justify="center" v-if="menus">
      <v-card width="100%">
        <v-card-title>
          {{ $t('Common.menus') }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="tableSearch"
            append-icon="mdi-magnify"
            :label="$t('Common.menus')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="menus"
          :loading="loading"
          :search="tableSearch"
          :items-per-page="5"
        >
          <template v-slot:no-data>
            <span>{{ $t('Common.no_menus_found') }}</span>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <span v-if="item.type === 'parent'">Parent Menu</span>
            <span v-else>Menu</span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-btn
              :to="'/profile/wizard/menus/menus_sub/edit_menu/' + item.id"
              depressed
              text
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.delete`]="{ item }">
            <v-icon small @click="deleteItemDialog(item.id)">delete</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-row>
    <!-- dish delete confirmation -->
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="mx-2">
          <v-icon large color="grey">delete</v-icon>
          <h4 class="ml-1 mt-2 fs-16 font-weight-medium">
            Are you sure you want to delete this menu?
          </h4>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red" dark @click="deleteItem()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      id: null,
      headers: [
        { text: 'Menu Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Edit', value: 'edit', sortable: false },
        { text: 'Delete', value: 'delete', sortable: false }
      ],
      tableSearch: '',
      deleteDialog: false
    }
  },
  beforeMount() {
    if (!this.menus || this.menus.length === 0) {
      this.loadMenus()
    }
  },
  computed: {
    ...mapGetters({
      menus: 'menus',
      profile: 'profile'
    }),

    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    loadMenus() {
      this.$store.dispatch('loadMenus', { uid: this.profile.id })
    },
    editItem(id) {
      this.$router.go('/profile/wizard/menus_sub/edit_menu/' + id)
    },
    deleteItemDialog(id) {
      this.deleteId = id
      this.deleteDialog = true
    },
    deleteItem() {
      const that = this
      this.$store.dispatch('deleteMenu', this.deleteId).then(() => {
        that.deleteDialog = false
        that.loadMenus()
      })
    }
  }
}
</script>
<style>
.v-stepper__header {
  box-shadow: none;
  justify-content: flex-start !important;
}
.v-stepper__content {
  padding: 16px 40px 16px 23px;
}
.v-stepper__wrapper {
  padding: 4px;
}
.shadow {
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 4px 8px rgba(0, 0, 0, 0.04);
}
</style>
